<template>
  <filter-summary
    icon="item"
    title="単品／商品分類"
    :scroll-to-id="scrollToId"
    v-on="$listeners"
    :errors="errors"
  >
    <div>{{ count }}{{ label }}</div>
  </filter-summary>
</template>

<script>
import FilterSummary from '@/components/FilterSummary.vue'

/**
 * 商品分類の分析条件サマリ
 */
export default {
  components: { FilterSummary },
  props: {
    scrollToId: String,
    isLeafCategory: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => ({}),
    },
    category: {
      type: Object,
      default: () => ({}),
    },
    errors: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    count() {
      if (this.errors.length > 0) {
        return ''
      }

      if (!this.isLeafCategory) {
        if (this.item.selectMode === 'category') {
          return this.item.categories ? this.item.categories.length : 0
        } else if (this.item.selectMode === 'item') {
          return this.item.items ? this.item.items.length : 0
        }
      } else if (this.isLeafCategory) {
        return this.category.categories.length
      }

      return undefined
    },
    label() {
      if (this.isLeafCategory) {
        return '分類'
      }

      return this.item.selectMode === 'item' ? '商品' : '分類'
    },
    listeners() {
      return {
        ...this.$listeners,
      }
    },
  },
}
</script>
